.monaco-editor .margin-view-overlays .cmdr{height:100%;left:0;position:absolute;width:100%}